export default {
  "tags": [
    {
      "value": "CONFIRMED_EVENT_UPDATE",
      "label": "facebook_tag_confirmed_event_update"
    },
    {
      "value": "POST_PURCHASE_UPDATE",
      "label": "facebook_tag_post_purchase_update"
    },
    {
      "value": "ACCOUNT_UPDATE",
      "label": "facebook_tag_account_update"
    }
    // {
    //   "value": "HUMAN_AGENT",
    //   "label": "facebook_tag_human_agent"
    // }
  ]
}